'use client';
import ScreenLayout from "@/components/layout/screen-layout";
import {
  Brand_Logo_Section_Build_Smart,
  Heading_Global_Businesses_BuildSmart,
} from "@/lib/dto/home/build-smart/build-smart-data";
import Image from "next/image";
import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

function BusinesseBrandLogoBuildSmart() {
  const [logos, setLogos] = useState(Brand_Logo_Section_Build_Smart);

  useEffect(() => {
    const shuffled = [...Brand_Logo_Section_Build_Smart].sort(
      () => Math.random() - 0.5
    );
    setLogos(shuffled);
  }, []);

  return (
    <ScreenLayout className="">
      <div className="flex flex-col justify-center items-center pt-4 pb-6.25 md:pt-8 md:pb-12.5">
        <h2 className="text-sm sm:text-sm md:text-base lg:text-lg font-semibold text-[#151A2880] opacity-50 uppercase">
          {Heading_Global_Businesses_BuildSmart.heading}
        </h2>
        <div className="md:py-11 py-5.5">
          {/* <div className="mx-auto md:mx-55"> */}
          <div className="px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 overflow-hidden w-full min-w-0 max-w-[100vw]">
            <Marquee
              autoFill
              gradient={false}
              pauseOnHover
              speed={50}
              className="w-full min-w-0"
              style={{ overflow: "hidden" }}
            >
              <div className="flex items-center">
                {logos.map((v, i) => (
                  <div
                    key={v.alt}
                    className="flex items-center justify-center mr-8 md:mr-14 shrink-0"
                  >
                    <Image
                      src={v.img}
                      alt={v.alt || `Brand logo ${i + 1}`}
                      className="h-8 md:h-12 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
            </Marquee>
          </div>
        </div>
      </div>
    </ScreenLayout>
  );
}

export default BusinesseBrandLogoBuildSmart;
